import styled from 'styled-components';
import { breakpoints, colors, pxToCssFont, pxToRem } from '@vfit/shared/themes';

export const Section = styled.section`
  margin-top: ${pxToRem(8)};

  > p + p {
    margin-top: ${pxToRem(32)};
  }
`;

export const P = styled.p`
  ${pxToCssFont(20, 26)};
  margin: 0;
  text-transform: capitalize;

  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFont(20, 30)};
  }
`;

export const Street = styled.span`
  font-weight: 700;
  ${pxToCssFont(20, 26)};
  color: ${colors.$e60000};
  margin: 0;

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(20, 30)};
  }
`;

